/// <reference path="../ObjectDataBuilder.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class SurveyBuilder
			extends ObjectDataBuilder<Wollmilch.Realtor.Object>
		{
			private SurveyBox: any;
			private SurveyCompany: any;

			public constructor( data: Wollmilch.Realtor.Object )
			{
				super( data );

				this.SurveyBox	= new ui.Box.Box();
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery, navigation: Navigation ): SurveyBuilder
			{
				this.SurveyCompany = app.getAuthenticationManager().getCompany();

				this.SurveyBox.rebuild( root.empty() );

				this.SurveyBox.append( new SPA.Survey.SurveyObjectCreator( this.SurveyCompany, this.m_Data ) );

				return this;
			}

		}

	}

}
